var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7875 2.50769C14.5775 2.23019 14.27 2.05019 13.9175 1.99769L3.52255 0.550187C2.80255 0.452687 2.14255 0.955187 2.04505 1.66769L0.800051 10.5777C0.747551 10.9227 0.837551 11.2677 1.04755 11.5527C1.25755 11.8377 1.56505 12.0102 1.91755 12.0627L9.47005 13.1202C9.56005 13.1352 9.65755 13.1427 9.74755 13.1427C10.1901 13.1427 10.64 13.0002 10.9925 12.7302L13.385 10.9227C13.82 10.5927 14.1125 10.0977 14.1875 9.56519L15.035 3.49769C15.0875 3.15269 14.9975 2.80769 14.7875 2.52269V2.50769ZM1.94755 10.8702C1.94755 10.8702 1.90255 10.7952 1.91005 10.7277L3.15505 1.81019C3.17005 1.70519 3.26005 1.63769 3.36505 1.65269L13.7675 3.10019C13.835 3.10769 13.8726 3.15269 13.8951 3.17519C13.9101 3.19769 13.94 3.25019 13.9325 3.31769L13.1825 8.70269L10.7675 8.36519C10.0475 8.26769 9.38755 8.77019 9.28255 9.48269L8.94505 11.8977L2.07505 10.9377C2.00755 10.9302 1.97005 10.8852 1.94755 10.8627V10.8702ZM10.3251 11.8152C10.2501 11.8677 10.1676 11.9052 10.0775 11.9352L10.4 9.64019C10.415 9.53519 10.5125 9.46769 10.61 9.48269L12.9051 9.80519C12.8526 9.88019 12.8 9.95519 12.725 10.0077L10.3325 11.8152H10.3251Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.d00530a78db01d617072412135b515dd.svg";
export { ForwardRef as ReactComponent };